import {toISODate, toInt} from "../../../../utils/convert-fields"
import {formatDateBr} from "../../../../utils/convert-fields"

export const dataAniversarioFields = [
    {"key": "ID", "label": "ID Data Aniversário"},
    {"key": "IDFluxoEvento", "label": "ID Fluxo Evento"},
    {"key": "DataReferencia", "label": "Data Referência"},
    {"key": "DataAniversarioAnterior", "label": "Data Aniversário Anterior"},
    {"key": "DataAniversario", "label": "Data Aniversário"},
    {"key": "CorrigeDataAniversario", "label": "Corrige Data Aniversário"},
    {"key": "AniversarioPeriodico", "label": "Aniversário Periódico"}
]

export const mapDataAniversarioPayload = (
    tableData = [],
    cetip,
    versaoDocumento,
    idCaracteristica
) => {
    const datasAniversario = tableData
        .filter(column =>
            column &&
            Object.keys(column).length > 0 &&
            Object.values(column).some(v => v !== "" && v !== null && v !== undefined)
        )
        .map((column) => ({
            RendaFixaCaracteristicasID: idCaracteristica,
            IDFluxoEvento: toInt(column.IDFluxoEvento) ?? null,
            CETIP: cetip,
            VersaoDocumento: toInt(versaoDocumento),
            DataReferencia: toISODate(column.DataReferencia),
            DataAniversarioAnterior: column.DataAniversarioAnterior ? toISODate(column.DataAniversarioAnterior) : "",
            DataAniversario: toISODate(column.DataAniversario),
            CorrigeDataAniversario: column.CorrigeDataAniversario ?? "",
            AniversarioPeriodico: toInt(column.AniversarioPeriodico) ?? null,
        }))

    return {
        CETIP: cetip || "",
        VersaoDocumento: toInt(versaoDocumento) ?? 0,
        DatasAniversario: datasAniversario,
    }
}

export const mapDataAniversarioToTable = (apiData = []) => {
    if (!apiData || apiData.length === 0) return [{}]

    return apiData.map(item => ({
        ID: item.ID,
        IDFluxoEvento: item.IDFluxoEvento || "",
        DataReferencia: item.DataReferencia ? formatDateBr(item.DataReferencia) : "",
        CETIP: item.CETIP || "",
        VersaoDocumento: item.VersaoDocumento ?? "",
        DataAniversarioAnterior: item.DataAniversarioAnterior ? formatDateBr(item.DataAniversarioAnterior) : "",
        DataAniversario: item.DataAniversario ? formatDateBr(item.DataAniversario) : "",
        CorrigeDataAniversario: item.CorrigeDataAniversario ?? "",
        AniversarioPeriodico: item.AniversarioPeriodico ?? ""
    }))
}